import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const RoleViewModule = new Module({
  id: 'ROLE:VIEW:RESULT-TABLE',
  name: 'Role',
  path: 'role',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Role/View'))
  ),
});

export const RoleAddModule = new Module({
  id: 'ROLE:CREATE:ADD-ROLE',
  name: 'roleAdd',
  path: 'role/add',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Role/Form'))
  ),
  actions: {
    add: {
      id: 'ROLE:CREATE:ADD-ROLE',
      name: 'add-role',
      label: 'Add role'
    }
  }
});

export const RoleEditModule = new Module({
  id: 'ROLE:EDIT:RESULT-TABLE',
  name: 'RoleEdit',
  path: 'role/edit',
  pathDef: 'role/edit/:id',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Role/Form'))
  ),
  actions: {
    edit: {
      id: 'ROLE:EDIT:RESULT-TABLE',
      name: 'edit-role-result-table',
      label: 'Edit'
    },
    delete: {
      id: 'ROLE:DELETE:RESULT-TABLE',
      name: 'delete-role-result-table',
      label: 'Delete'
    },
    sendMail: {
      id: 'ROLE:VIEW:MAIL-SENT',
      name: 'send-mail-item',
      label: 'Send Mail'
    }
  }
});

const RoleModules = [RoleViewModule, RoleEditModule, RoleAddModule];

export default new ModuleBundle('Role', RoleModules);
